import { ThunkDispatch } from '@reduxjs/toolkit'
import { SocketEvent } from 'interface'
import { io } from 'socket.io-client'
import { getEvent } from './slices/Event'
import { getAuth } from './slices/UI'
import type { RootState } from './store'

export class SocketClient {
  private dispatch: ThunkDispatch<any, any, any>
  private rootState: RootState
  constructor(dispatch: ThunkDispatch<any, any, any>, rootState: RootState) {
    this.dispatch = dispatch
    this.rootState = rootState
  }
  connect() {
    const socket = io(
      process.env.NODE_ENV === 'development'
        ? 'http://' + window.location.hostname + ':5000'
        : '/',
      {
        path: '/game-io',
        auth: { ...this.rootState.UI.auth, client: 'user' },
        transports: ['websocket', 'polling'],
      }
    )
    socket.on('connect_error', () => {
      socket.io.opts.transports = ['polling', 'websocket']
    })
    socket.on('connect', () => {
      socket.on('disconnect', (r) => {
        console.log('Socket is disconnected, ' + r)
      })

      // templateIO
      socket.on('templateIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            break
          case 'deleted':
            break
          case 'updated':
            break
          default:
            break
        }
      })

      // eventIO
      socket.on('eventIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(getEvent(event.id))
            break
          case 'updated':
            this.dispatch(getEvent(event.id))
            break
          default:
            break
        }
      })

      // templateIO
      socket.on('userIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            break
          case 'deleted':
            break
          case 'updated':
            this.dispatch(getAuth())
            break
          default:
            break
        }
      })

      // =============
    })
  }
}
